import _ from "lodash";


import state from "../state";
import env from "../constants/env";

export const RESOURCE_REFERENCE = "resource/ref";

/**
 * Call this to initialize the drive when the component mounts
 * @param {*} drive 
 */
export function initializeDrive(drive) {
	state.set(["drive"], drive);
}

export function isDriveReference(obj) {
	return obj && obj.hasOwnProperty("type") && obj.type === RESOURCE_REFERENCE;
}

export function getUrlForValue2(value, activityId = null) {
    return value;
}

function getActivityOrCurrentlySelected(activityId = null) {
	return state.get(["activity"]);
}


function getResource(id, activity) {
	let result = null;
	if (!activity) {
		activity = getActivityOrCurrentlySelected();
	}
	if (activity) {
		_.forEach(activity.externalResources, extResource => {
			if (extResource.id === id) {
				result = extResource;
			}
		});
	}
	return result;
}

export function getResourceForReference(ref, activityId = null) {
	const { refId } = ref;
	// Get the current activity
	const activity = getActivityOrCurrentlySelected(activityId);
	console.log("Got activity for resource reference resolution", activity, ref);
	if (activity) {
		return getResource(refId, activity);
	} else {
		throw new Error("No activity is currently selected.");
	}
}

export function getExternalResourceInfos() {
	return state.get(["drive", "guidToResource"]);
}

export function getExternalResourceInfo(guid) {
	const resourceInfos = getExternalResourceInfos();
	let result = null;
	if (resourceInfos[guid]) {
		result = resourceInfos[guid];
	}
	return result;
}

export function getUrlForResource(resource) {
	const externalResource = getExternalResourceInfo(resource.guid);
	if (externalResource) {

		return getUrlForExternalResource(externalResource);

	} else {
		throw new Error(`Unable to find external resoruce for guid ${resource.guid}`);
	}
}

export function getUrlForExternalResource(externalResource) {
	const urlPrefix = (externalResource.private) ? env.cloudFront.assetUrls.private : env.cloudFront.assetUrls.public;
	if (externalResource.path && externalResource.path.replace) {
		return `${urlPrefix}/${externalResource.path.replace(/^public\//, "").replace(/^private\//, "")}?v=${externalResource.revision}`;
	} else {
		return "";
	}
}

export function getUrlForValue(value, activityId = null) {
	let result = value;
	if (!_.isString(value) && isDriveReference(value)) {
		try {
			console.log("PLAYER: Got drive reference", value);
			const expandedValue = getResourceForReference(value, activityId);
			console.log("PLAYER: Got drive reference expanded value", expandedValue);
			result = getUrlForResource(expandedValue, activityId);
			console.log("PLAYER: Resolved drive reference", result);
		} catch (err) {
			console.warn(err);
		}
	}

	return result;
}